import React, {useEffect, useRef, useState} from "react";
import {BROADCAST_ON_SUBMIT_FIND_PASSWORD, useApplicationContext} from "../../../context/ApplicationContextProvider";
import styled from "@emotion/styled";
import CustomInput from "../../_common/component/CustomInput";
import {REGEX_EMAIL} from "../../../constant/regexs";
import SubmitButton from "../../_common/component/SubmitButton";
import {lang} from "../../../lang";
import {useModelContext} from "../../../context/ModelContextProvider";
import {useNavigate} from "react-router-dom";
import {useDialogContext} from "../../../context/DialogContextProvider";
import Log from "../../../common/Log";

const FindPasswordForm = () => {
    const {broadcast} = useApplicationContext();
    const {alert} = useDialogContext();
    const {account_model, isSuccess, isError} = useModelContext();
    const navigate = useNavigate();

    // state
    const [email_error, setEmailError] = useState(false);
    const [is_loading, setIsLoading] = useState(false);

    // ref
    const find_user_password_info = useRef({
        email: {
            value: undefined,
            error_msg: null,
        },
    });

    // css style
    const {view} = useComponentStyle();

    useEffect(() => {
        const unlisten = broadcast.listen([BROADCAST_ON_SUBMIT_FIND_PASSWORD], ({value}) => {
            value && validateInputValue();
        });
        return () => {
            broadcast.unlisten(unlisten);
        };
    }, [broadcast]);

    const validateInputValue = async () => {
        let email = find_user_password_info.current.email.value;

        // email이 없는경우
        if (!email) {
            find_user_password_info.current.email.error_msg = lang.login.empty_login_email;
        } else {
            if (!REGEX_EMAIL.test(email))
                find_user_password_info.current.email.error_msg = lang.login.check_login_email;
        }

        if (find_user_password_info.current.email.error_msg === null) {
            setEmailError(false);
            await submitFindPassword();
        } else {
            setEmailError(true);
        }
    };

    const submitFindPassword = async () => {
        setIsLoading(true);

        const find_password_res = await account_model.postFindPassword(find_user_password_info.current.email.value);
        if (isSuccess(find_password_res)) {
            alert(lang.find_account.send_init_password_to_email);
            navigate("/");
        } else if (isError(find_password_res)) {
            if (find_password_res.code === 4500) {
                alert(lang.find_account.does_not_exist_user);
            } else {
                alert(lang.request.request_error);
            }
            Log.private("postFindPassword 에러", find_password_res);
        }

        setIsLoading(false);
    };

    return (
        <>
            <view.FindPasswordFormSection>
                <CustomInput
                    placeholder={"이메일 주소를 입력해주세요."}
                    name={"account"}
                    label_name={"이메일"}
                    regex={REGEX_EMAIL}
                    on_change={(text) => (find_user_password_info.current.email.value = text)}
                    current_value={find_user_password_info.current.email}
                    is_error={email_error}
                />
            </view.FindPasswordFormSection>
            <SubmitButton
                on_click={async () => {
                    await validateInputValue();
                }}
                button_text={"확인"}
                margin_top={"5em"}
                is_loading={is_loading}
            />
        </>
    );
};

export default FindPasswordForm;

export const useComponentStyle = () => {
    return {
        view: {
            FindPasswordFormSection: styled.div({
                marginTop: "4em",
                "& > div": {
                    marginTop: "2em",
                    marginBottom: "3em",
                },
            }),
        },
    };
};
